import { featureFlagClient } from '@trello/feature-flag-client';

export const memberRoutesViewLoaders = {
  memberAccount: () => {
    return import(/* webpackChunkName: "member-account-view" */ 'app/scripts/views/member/member-account-view.coffee').then(
      (m) => m.default,
    );
  },
  memberBilling: () => {
    return import(/* webpackChunkName: "member-billing-view" */ 'app/scripts/views/member/member-billing-view.coffee').then(
      (m) => m.default,
    );
  },
  memberCards: () => {
    return import(/* webpackChunkName: "member-cards-view" */ 'app/scripts/views/member/member-cards-view.coffee').then(
      (m) => m.default,
    );
  },
  memberProfile: () => {
    if (featureFlagClient.get('treehouse.web.profile-redesign')) {
      return import(/* webpackChunkName: "member-profile-view" */ 'app/scripts/views/member-home-profile-tab').then(
        (m) => m.MemberHomeProfileTab,
      );
    } else {
      return import(/* webpackChunkName: "member-profile-view" */ 'app/scripts/views/member/member-profile-view.coffee').then(
        (m) => m.default,
      );
    }
  },
  memberActivity: () => {
    return import(/* webpackChunkName: "member-activity-view" */ 'app/scripts/views/member/member-activity-view.coffee').then(
      (m) => m.default,
    );
  },
};
